import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './frontend/Home';
import Blog from './frontend/Blog';
import AdminApp from './admin/AdminApp';
import SEO from './frontend/components/SEO';

function App() {
  return (
    <BrowserRouter>
      <SEO />
      <Routes>
        {/* Admin Routes */}
        <Route path="/admin/*" element={<AdminApp />} />
        
        {/* Public Routes */}
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<Blog />} />
        <Route path="/*" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
